const uploadAssetToS3 = () => {};

export default uploadAssetToS3;
